/* ==========================================
   WATCH & BUY
   File: assets/watch-and-buy.js
   FINAL SOUND / VIDEO VERSION
========================================== */

(function () {
  "use strict";

  function initWatchBuy(section) {

    if (!section) return;

    if (section.dataset.initialized === "true") {
      return;
    }

    section.dataset.initialized = "true";

    const track = section.querySelector(".watch-buy__track");
    const leftArrow = section.querySelector(".watch-buy__arrow--left");
    const rightArrow = section.querySelector(".watch-buy__arrow--right");

    const cards = section.querySelectorAll(".watch-buy__card");
    const videos = section.querySelectorAll(
      ".watch-buy__video-element"
    );

    if (!track) return;


    /* ==========================================
       SCROLL
    ========================================== */

    function getScrollAmount() {

      const firstCard = cards[0];

      if (!firstCard) {
        return 300;
      }

      const style = window.getComputedStyle(track);

      const gap =
        parseInt(
          style.gap ||
          style.columnGap ||
          "22",
          10
        ) || 22;

      return firstCard.offsetWidth + gap;
    }


    if (leftArrow) {

      leftArrow.addEventListener("click", function () {

        track.scrollBy({
          left: -getScrollAmount(),
          behavior: "smooth"
        });

      });

    }


    if (rightArrow) {

      rightArrow.addEventListener("click", function () {

        track.scrollBy({
          left: getScrollAmount(),
          behavior: "smooth"
        });

      });

    }


    function updateArrows() {

      const maxScroll =
        track.scrollWidth - track.clientWidth;

      if (leftArrow) {

        if (track.scrollLeft <= 10) {

          leftArrow.style.opacity = "0";
          leftArrow.style.pointerEvents = "none";

        } else {

          leftArrow.style.opacity = "1";
          leftArrow.style.pointerEvents = "auto";

        }

      }


      if (rightArrow) {

        if (track.scrollLeft >= maxScroll - 10) {

          rightArrow.style.opacity = "0";
          rightArrow.style.pointerEvents = "none";

        } else {

          rightArrow.style.opacity = "1";
          rightArrow.style.pointerEvents = "auto";

        }

      }

    }


    track.addEventListener(
      "scroll",
      updateArrows,
      { passive: true }
    );

    updateArrows();


    /* ==========================================
       VIDEO SETUP
    ========================================== */

    videos.forEach(function (video) {

      video.loop = true;
      video.playsInline = true;

      video.setAttribute(
        "playsinline",
        ""
      );

      video.setAttribute(
        "webkit-playsinline",
        ""
      );

      /*
        Start muted for autoplay.
      */

      video.muted = true;
      video.defaultMuted = true;
      video.volume = 1;

    });


    /* ==========================================
       AUTOPLAY / VISIBILITY
    ========================================== */

    if (
      videos.length &&
      "IntersectionObserver" in window
    ) {

      const observer =
        new IntersectionObserver(
          function (entries) {

            entries.forEach(function (entry) {

              const video = entry.target;

              if (entry.isIntersecting) {

                video.play().catch(function () {});

              } else {

                video.pause();

              }

            });

          },
          {
            threshold: 0.45
          }
        );


      videos.forEach(function (video) {

        observer.observe(video);

      });

    }


    /* ==========================================
       SOUND BUTTON
    ========================================== */

    const soundButtons =
      section.querySelectorAll(
        ".watch-buy__mute"
      );


    soundButtons.forEach(function (button) {

      if (
        button.dataset.soundReady === "true"
      ) {
        return;
      }

      button.dataset.soundReady = "true";


      button.addEventListener(
        "click",
        function (event) {

          event.preventDefault();
          event.stopPropagation();


          const card =
            button.closest(
              ".watch-buy__card"
            );


          if (!card) return;


          const video =
            card.querySelector(
              ".watch-buy__video-element"
            );


          if (!video) return;


          /* ==================================
             TURN SOUND ON
          ================================== */

          if (video.muted === true) {

            /*
              VERY IMPORTANT:

              Remove muted attribute from
              HTML video element.
            */

            video.removeAttribute(
              "muted"
            );

            /*
              Change both JS properties.
            */

            video.defaultMuted = false;
            video.muted = false;

            /*
              Set volume.
            */

            video.volume = 1;


            /*
              Play after user interaction.
            */

            const playPromise =
              video.play();


            if (
              playPromise &&
              typeof playPromise.then === "function"
            ) {

              playPromise
                .then(function () {

                  setSoundOn(
                    button
                  );

                })
                .catch(function () {

                  /*
                    Try one more time after
                    forcing unmute.
                  */

                  video.removeAttribute(
                    "muted"
                  );

                  video.defaultMuted = false;
                  video.muted = false;
                  video.volume = 1;

                  video.play().catch(
                    function () {}
                  );

                  setSoundOn(
                    button
                  );

                });

            } else {

              setSoundOn(
                button
              );

            }


          } else {

            /* ==================================
               TURN SOUND OFF
            ================================== */

            video.muted = true;
            video.defaultMuted = true;

            video.setAttribute(
              "muted",
              ""
            );

            setSoundOff(
              button
            );

          }

        },
        true
      );

    });


    /* ==========================================
       SOUND ON UI
    ========================================== */

    function setSoundOn(button) {

      button.classList.add(
        "is-active"
      );

      button.setAttribute(
        "aria-label",
        "Mute video"
      );

      button.setAttribute(
        "aria-pressed",
        "true"
      );

      button.style.background =
        "rgba(34,197,94,.9)";


      const mutedIcon =
        button.querySelector(
          ".watch-buy__icon-muted"
        );

      const soundIcon =
        button.querySelector(
          ".watch-buy__icon-sound"
        );


      if (mutedIcon) {

        mutedIcon.style.display =
          "none";

      }


      if (soundIcon) {

        soundIcon.style.display =
          "block";

      }

    }


    /* ==========================================
       SOUND OFF UI
    ========================================== */

    function setSoundOff(button) {

      button.classList.remove(
        "is-active"
      );

      button.setAttribute(
        "aria-label",
        "Unmute video"
      );

      button.setAttribute(
        "aria-pressed",
        "false"
      );

      button.style.background =
        "rgba(17,17,17,.72)";


      const mutedIcon =
        button.querySelector(
          ".watch-buy__icon-muted"
        );

      const soundIcon =
        button.querySelector(
          ".watch-buy__icon-sound"
        );


      if (mutedIcon) {

        mutedIcon.style.display =
          "block";

      }


      if (soundIcon) {

        soundIcon.style.display =
          "none";

      }

    }


    /* ==========================================
       VIDEO CLICK PLAY / PAUSE
    ========================================== */

    videos.forEach(function (video) {

      if (
        video.dataset.clickReady === "true"
      ) {
        return;
      }

      video.dataset.clickReady = "true";


      video.addEventListener(
        "click",
        function () {

          if (video.paused) {

            video.play().catch(
              function () {}
            );

          } else {

            video.pause();

          }

        }
      );

    });


    /* ==========================================
       KEYBOARD
    ========================================== */

    section.addEventListener(
      "keydown",
      function (event) {

        if (
          event.key === "ArrowLeft"
        ) {

          track.scrollBy({
            left: -getScrollAmount(),
            behavior: "smooth"
          });

        }


        if (
          event.key === "ArrowRight"
        ) {

          track.scrollBy({
            left: getScrollAmount(),
            behavior: "smooth"
          });

        }

      }
    );


    /* ==========================================
       RESIZE
    ========================================== */

    let resizeTimer;

    window.addEventListener(
      "resize",
      function () {

        clearTimeout(
          resizeTimer
        );

        resizeTimer =
          setTimeout(
            function () {

              updateArrows();

            },
            150
          );

      }
    );

  }


  /* ==========================================
     INITIALIZE
  ========================================== */

  function initialize() {

    document
      .querySelectorAll(
        ".watch-buy"
      )
      .forEach(function (section) {

        initWatchBuy(
          section
        );

      });

  }


  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initialize
    );

  } else {

    initialize();

  }


  /* ==========================================
     SHOPIFY THEME EDITOR
  ========================================== */

  document.addEventListener(
    "shopify:section:load",
    function (event) {

      const section =
        event.target.querySelector(
          ".watch-buy"
        ) ||
        event.target;


      if (section) {

        section.dataset.initialized =
          "false";

        initWatchBuy(
          section
        );

      }

    }
  );


  document.addEventListener(
    "shopify:section:select",
    function (event) {

      const section =
        event.target.querySelector(
          ".watch-buy"
        ) ||
        event.target;


      if (section) {

        initWatchBuy(
          section
        );

      }

    }
  );


})();